import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { ChartCustomization } from "@brasilnovo/shared";
import { api } from "./api.js";

type PrefMap = Record<string, ChartCustomization>;

// Carrega TODAS as preferências do usuário uma vez (cacheadas) e expõe
// get/save/reset por chave de gráfico. Persiste no servidor (segue o usuário).
export function useChartPrefs(chartKey: string) {
  const qc = useQueryClient();
  const all = useQuery({
    queryKey: ["chart-prefs"],
    queryFn: async () => (await api.get("/chart-prefs")).data as PrefMap,
    staleTime: 60_000,
  });
  const custom: ChartCustomization = all.data?.[chartKey] ?? {};

  const save = useMutation({
    mutationFn: async (c: ChartCustomization) =>
      (await api.put(`/chart-prefs/${encodeURIComponent(chartKey)}`, c)).data as ChartCustomization,
    onSuccess: (data) =>
      qc.setQueryData<PrefMap>(["chart-prefs"], (prev) => ({ ...(prev ?? {}), [chartKey]: data })),
  });

  const reset = useMutation({
    mutationFn: async () => { await api.delete(`/chart-prefs/${encodeURIComponent(chartKey)}`); },
    onSuccess: () =>
      qc.setQueryData<PrefMap>(["chart-prefs"], (prev) => {
        const next = { ...(prev ?? {}) };
        delete next[chartKey];
        return next;
      }),
  });

  return { custom, loaded: all.isSuccess, save: save.mutate, reset: reset.mutate };
}
